import { Button, message } from "antd"
import { checkActionAllowed } from "../../utils/utilities"
import { showConfirm } from "../custom-components/custom-component";
import { validateOtaAction } from "./ota-validation.module";
import { useDispatch } from "react-redux";
import { loadingAction } from "../../actions/loading-actions";


export const OTAValidationComponent = (props) => {

    const {
        tripRouteId
    } = props;

    const dispatch = useDispatch();

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }
    
    if(checkActionAllowed('SHOW_OTA_VALIDATION_BUTTON')){
        return (
            <div className="ota-validation-component"
            onClick={()=>{
                showConfirm(()=>{
                    setLoading(true);
                    validateOtaAction(tripRouteId,(msg)=>{
                        setLoading(false);
                        message.success(msg);
                    },(error)=>{
                        setLoading(false);
                        message.error(error);
                    })
                },'Validate OTA Action','Are you sure you want to validate the OTA action?')
            }}
            >
                <Button className="bordered-btn send-driver-details-btn">OTA Validation</Button>
            </div>
        );
    }else{
        return null;
    }
}

